import { getCurrentInstance, onBeforeUnmount, unref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { appBackCoordinator } from '@/utils/appBackCoordinator';

const createInstanceId = (baseId) => {
  const instance = getCurrentInstance();
  return `${baseId}:${instance?.uid ?? 'global'}`;
};

export const useBackLayer = ({ id, isOpen, dismissible = true, closeFromBack }) => {
  const registration = appBackCoordinator.registerLayer({
    id: createInstanceId(id),
    dismissible,
    closeFromBack,
  });

  const stop = watch(
    () => !!unref(isOpen),
    (open) => registration.setOpen(open),
    { flush: 'sync', immediate: true },
  );

  onBeforeUnmount(() => {
    stop();
    registration.unregister();
  });

  return registration;
};

export const useBackReducer = ({ id, canUnwind, unwindOne, getDepth }) => {
  const route = useRoute();
  const routePath = route.path;
  const registration = appBackCoordinator.registerReducer({
    id: createInstanceId(id),
    unwindOne,
    getDepth,
    route: routePath,
  });

  const stop = watch(
    [() => !!canUnwind(), () => (getDepth ? getDepth() : undefined)],
    ([active]) => registration.setActive(active),
    { flush: 'sync', immediate: true },
  );

  onBeforeUnmount(() => {
    stop();
    registration.unregister();
  });

  return registration;
};

export const useAppBack = () => {
  return {
    performOneBack: () => appBackCoordinator.performOneBack(),
  };
};
